import React, { Fragment } from 'react'

export default class StickyFooterActions extends React.Component {
  constructor() {
    super()

    this.state = {
      footerHeight: 0,
      sticky: false,
    }

    this.setStickiness = this.setStickiness.bind(this)
  }

  componentDidMount() {
    const footerElement = document.getElementsByClassName('responsive-footer')[0]
    const footerHeight = footerElement ? footerElement.clientHeight : 0

    this.setState({ footerHeight: footerHeight - 95 })
    window.addEventListener('scroll', this.setStickiness)
    this.setStickiness()
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.setStickiness)
  }

  setStickiness() {
    if (window.scrollY + window.innerHeight - this.state.footerHeight < this.el.offsetTop) {
      this.setState({ sticky: true })
    } else {
      this.setState({ sticky: false })
    }
  }

  render() {
    const className = this.state.sticky ? `${this.props.className} form-footer__wrapper--sticky` : this.props.className

    return (
      <Fragment>
        <div className="form-footer__beacon" ref={(el) => { this.el = el }} />
        <div className={className}>
          {this.props.children}
        </div>
      </Fragment>
    )
  }
}
